export default {
  url: 'URL',
  ptDbId: 'PT-Datenbank-ID',
};
